import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './iw_v2/Header';
import Footer from './iw_v2/Footer';
import Home from './iw_v2/Home';
import Jobs from './iw_v2/Jobs';
import Safety from './iw_v2/Safety';
import Bid from './iw_v2/Bid';

export default function ConstructionTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#D9D4CC]" data-testid="iw-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.35 }} data-testid={`iw-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'jobs' && <Jobs setPage={setPage} />}
          {page === 'safety' && <Safety setPage={setPage} />}
          {page === 'bid' && <Bid setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
